import * as React from "react";
import {Route} from "react-router";

import Chat from "./chat/chat/Chat";

export default class App extends React.Component {
    public render() {
        return (
            <section className="no-padding">
                <Route path="*" component={Chat} exact={true} />
            </section>
        );
    }
}
